// The recent-chat list is needed only while the portal chat panel is open.
// Keep this tiny shared state outside React so realtime listeners can check it
// without mounting the chat UI on every portal page.
let portalChatOpen = false;

export const setPortalChatOpen = (isOpen) => {
    portalChatOpen = Boolean(isOpen);
};

export const isPortalChatOpen = () => portalChatOpen;
